import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { OverlaySpinnerComponent } from './overlay-spinner/overlay-spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    OverlaySpinnerComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,

    MatProgressSpinnerModule
  ]
})
export class SharedModule { }
